import type { JSX } from "react";
interface Props {
  name: string;
  description: string;
}

const PrizeData = (props: Props): JSX.Element => (
  <section className="container py-4 mx-auto px-4 sm:mx-0 sm:pt-0 sm:px-0">
    <h1 className="mb-5">{props.name}</h1>
    <p className="lg:text-xl overflow-auto">{props.description}</p>
  </section>
);

export default PrizeData;
